import { render, staticRenderFns } from "./input-number-range.vue?vue&type=template&id=2938a483&scoped=true"
import script from "./input-number-range.vue?vue&type=script&lang=ts"
export * from "./input-number-range.vue?vue&type=script&lang=ts"
import style0 from "./input-number-range.vue?vue&type=style&index=0&id=2938a483&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938a483",
  null
  
)

export default component.exports